export default __webpack_public_path__ + "static/media/5-17_Es.efc99b5c.svg";